import { useShallow } from 'zustand/react/shallow';
import { useTeamsStore, type TeamsState } from '@store/teamsStore';

/**
 * useTeamsData(selector) — subscribe to a specific slice of teams state.
 *
 * Each component should select only the fields it uses. This prevents
 * unnecessary re-renders when unrelated state (e.g. teamMessages, modal)
 * changes elsewhere in the store.
 *
 * Examples:
 *   const { user, currentTeam } = useTeamsData(s => ({ user: s.user, currentTeam: s.currentTeam }));
 *   const user = useTeamsData(s => s.user);
 *   const doLogout = useTeamsData(s => s.doLogout);
 */
export function useTeamsData<T>(selector: (state: TeamsState) => T): T {
  return useTeamsStore(useShallow(selector));
}
